import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { SupplierCategoryFormDialog } from "../supplier-category-form-dialog";

import { Button } from "@mui/material";

export const EditSupplierCategoryFormDialog = ({
  supplierCategoryId,
  onClose,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchSupplierCategory = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, status },
          },
        } = await apiClient.get(`supplier-categories/${supplierCategoryId}`);
        setDefaultValues({
          name,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupplierCategory();
  }, [supplierCategoryId]);

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.put(`supplier-categories/${supplierCategoryId}`, {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui kategori pemasok"));

      throw error;
    }
  };

  return (
    <SupplierCategoryFormDialog
      dialogTitle="Ubah Kategori Pemasok"
      onClose={onClose}
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditSupplierCategoryFormDialog.propTypes = {
  supplierCategoryId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
